export class PaymentProcessController {
  constructor($scope, $rootScope, $location, $timeout, PaymentService) {
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.location = $location;
    this.timeout = $timeout;
    this.PaymentService = PaymentService;

    this.init();
  }

  init() {
    if(!this.rootScope.payment_price || !this.rootScope.payment_days) {
      this.location.path('/homerd/centrodepago');
    }

    this.PaymentService.initServipag(this.rootScope.currentUserProfile._id, this.rootScope.payment_price, this.rootScope.payment_days)
      .then((response) => { let data = response.data;
        this.scope.xml = data.message
        this.timeout(function() {
          angular.element("#frmServipag").submit();
        });
      })
      .catch((response) => { let error = response.data;
        console.log(error);
        this.location.path('/homerd/centrodepago/fail')
      });
  }
}
